export default "__VITE_ASSET__id8M3Z3C__"